export default {
  install(app) {
    // Eagerly load SVG files from the icons directory
    const iconsRaw = import.meta.glob('/src/assets/icons/*.svg', { query: '?raw', import: 'default', eager: true });
    // Reduce the loaded SVGs into a centralized object
    const icons = Object.entries(iconsRaw).reduce((acc, [path, content]) => {
      const fileName = path.replace(/^.*\/([^/]+)\.svg$/, '$1'); // Extract file name (without .svg)
      acc[fileName] = content; // Store raw SVG markup
      return acc;
    }, {});

    Object.keys(icons).forEach((name) => {
      app.component(name, {
        data() {
          return {
            iconContent: icons[name], // Assign raw SVG content
          };
        },
        template: '<span v-html="iconContent"></span>',
      });
    });
  },
};
